import 'flag-icons/css/flag-icons.min.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Navbar,
  Hero,
  About,
  Experience,
  Projects,
  Contact,
  Footer,
} from './components';

const App = () => {
  const { i18n } = useTranslation();
  const [isLangReady, setIsLangReady] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langFromUrl = urlParams.get('lang');
    const initialLang = langFromUrl || 'en';

    i18n.changeLanguage(initialLang).then(() => {
      setIsLangReady(true);
    });
  }, []);

  if (!isLangReady) {
    return <div className="w-full h-screen bg-primary" />;
  }

  return (
    <BrowserRouter>
      <div className="relative z-0 bg-primary">
        <Navbar />
        <main>
          <div id="hero" className="z-10">
            <Hero />
          </div>
          <div id="about" className="relative z-20 bg-[#011825] mt-[-2px]">
            <About />
          </div>
          <div id="experience" className="relative z-30 bg-primary">
            <Experience />
          </div>
          <div id="projects" className="relative z-30 bg-primary">
            <Projects />
          </div>
          <div id="contact" className="relative z-30 bg-primary">
            <Contact />
          </div>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
